import React from 'react';
import { IconButton, Stack, Typography } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

interface Props {
  title: string;
  count: number;
  ageRange: string;
  onIncrement: () => void;
  onDecrement: () => void;
}

export const PassengerTicketCounter = ({ title, count, ageRange, onIncrement, onDecrement }: Props) => {
  const handleIncrementClick = (event) => {
    event.stopPropagation();
    onIncrement();
  };

  const handleDecrementClick = (event) => {
    event.stopPropagation();
    onDecrement();
  };

  return (
    <Stack width="auto" gap="8px">
      <Stack gap="16px" direction="row" alignItems="center">
        <IconButton onClick={handleDecrementClick} sx={{ padding: 0 }}>
          <RemoveCircleIcon color="primary" />
        </IconButton>
        <Typography color="primary" variant="body2" fontWeight={700}>
          {count}
        </Typography>
        <IconButton onClick={handleIncrementClick} sx={{ padding: 0 }}>
          <AddCircleIcon color="primary" />
        </IconButton>
      </Stack>
      <Stack gap="4px">
        <Typography color="secondary" variant="body2" fontWeight={700}>
          {title}
        </Typography>
        <Typography color="secondary.contrastText" variant="caption" fontWeight={700}>
          {ageRange}
        </Typography>
      </Stack>
    </Stack>
  );
};
